'use strict';

var _ = require('lodash');
var RsqlQueryGroupStrategies = function RsqlQueryGroupStrategies(RsqlQuery, rsqlQueryService, criteriaRuleService, criteriaRuleDataService, momentService, UserSearchService) {
  var EMPTY_VALUE = '';
  var SPECIAL_CHARACTERS_REGEX = /([&\/\\#,+()_$~%.'":*?<>{}])/g;
  function defaultStrategy(field, rules) {
    return defaultStrategyWithMakingShortcut(field, rules, true, true);
  }
  function alwaysSendValuesStrategy(field, rules) {
    return defaultStrategyWithMakingShortcut(field, rules, false, true);
  }
  function transformDateToMongoEquality(rule, method, transformToDateTime) {
    var methodToRSQL = {
      equalTo: 'Between',
      notEqualTo: 'notbetween'
    };
    rule.leftOperand = transformToDateTime ? transformToIncludeTime(rule.leftOperand).startOf('day') : rule.leftOperand.startOf('day');
    rule.rightOperand = transformToDateTime ? transformToIncludeTime(rule.leftOperand).clone().endOf('day') : rule.leftOperand.clone().endOf('day');
    return rsqlQueryService.getRsqlOperator(methodToRSQL[method], rule.leftOperand, rule.rightOperand || rule.leftOperand);
  }
  function defaultStrategyWithMakingShortcut(field, rules, makeShortcut, skipConditionEscaping) {
    var originalOperator = rules[0].operator === '=' ? '==' : '!=';
    return _.chain(rules).map(function (rule) {
      var type = criteriaRuleService.getValueType(rule.searchContext, rule.level, rule.category, rule.criterion, rule.operator);
      if (type === 'multi') {
        if (makeShortcut) {
          rule = updateSingleMultiRule(rule);
        }
        if (equalAllSelectedRule(rule)) {
          return null;
        }
        extendUserRule(rule);
      }
      var method = rsqlQueryService.getRsqlOperator(rule.operator, rule.leftOperand, rule.rightOperand || rule.leftOperand);

      /**
       * The equality on mongodb for date fields it means exactly the value that ask
       * the solution is transform that equalty to between startOf day and endOf day
       */
      if (type === 'date' && _.includes(['equalTo', 'notEqualTo'], method)) {
        method = transformDateToMongoEquality(rule, method);
      }
      if (type === 'utcdate' && _.includes(['equalTo', 'notEqualTo'], method) && rule.field === 'eventTimeStamp') {
        method = transformDateToMongoEquality(rule, method, true);
      }
      if (type === 'text' && method === 'contains') {
        rule.leftOperand = rule.leftOperand.replace(SPECIAL_CHARACTERS_REGEX, '\\$1');
      }
      var rsqlQuery = new RsqlQuery();
      var groupQuery = new RsqlQuery();
      var carriers = rule.leftOperand2;
      var carrierField = 'system-status-fares-reopt' === rule.searchContext ? 'events[].carrier' : 'carrier';
      var queryBuilder = rsqlQuery.is(field);
      queryBuilder = queryBuilder[method].call(queryBuilder, rsqlQueryService.formatOperand(rule.leftOperand, type, skipConditionEscaping), rsqlQueryService.formatOperand(rule.rightOperand, type, skipConditionEscaping));
      if (!_.isUndefined(carriers) && !_.isEmpty(carriers)) {
        if ('out' === method) {
          queryBuilder = originalOperator !== rule.operator ? queryBuilder.and().is(carrierField)[method](carriers) : queryBuilder.or().is(carrierField)[method](carriers);
        } else {
          queryBuilder = queryBuilder.and().is(carrierField)[method](carriers);
        }
      }
      return groupQuery.and().orGroup(queryBuilder);
    }).reject(_.isNull).value();
  }
  function extendUserRule(rule) {
    if (['adjustmentsHistory.appliedBy'].indexOf(rule.field) > -1) {
      var leftOperand = [];
      _.transform(rule.leftOperand, function (result, userId) {
        result.push(userId);
        var userDisplayName = UserSearchService.getUserDisplayNameFromId(userId);
        if (userDisplayName) {
          result.push(userDisplayName.getDisplayName());
        }
      }, leftOperand);
      rule.leftOperand = leftOperand;
      return rule;
    }
  }
  function createRuleForAllDataSelected(rule, dropDown2Data) {
    rule = rule.clone();
    rule.operator = rule.operator === '=' ? '!=' : '=';
    rule.leftOperand = EMPTY_VALUE;
    rule.rightOperand = EMPTY_VALUE;
    if (_.isArray(rule.leftOperand2) && dropDown2Data) {
      rule.leftOperand2 = getDifferenceValue(dropDown2Data, rule.leftOperand2);
    }
    return rule;
  }
  function getDifferenceValue(dropDownData, leftOperand) {
    var dropdownValues = _.map(dropDownData, function (el) {
      return el.value || el;
    });
    return _.difference(dropdownValues, leftOperand);
  }
  function createReversedShorterRuleForUnselectedData(rule, dropDownData, dropDown2Data) {
    var differenceValue = getDifferenceValue(dropDownData, rule.leftOperand);
    var differenceValue2;
    if (_.isArray(rule.leftOperand2) && dropDown2Data) {
      differenceValue2 = getDifferenceValue(dropDown2Data, rule.leftOperand2);
    }
    rule = rule.clone();
    rule.operator = rule.operator === '=' ? '!=' : '=';
    rule.leftOperand = differenceValue;
    rule.rightOperand = differenceValue;
    if (_.isArray(differenceValue2)) {
      rule.leftOperand2 = differenceValue2;
    }
    return rule;
  }
  function updateSingleMultiRule(rule) {
    var type = 'multi';
    var criteriaNameForData = criteriaRuleService.getCriteriaNameForData(rule.searchContext, rule.category, rule.criterion);
    var dropDownData = criteriaRuleDataService.getOperandData(criteriaNameForData || rule.criterion, rule.operator, type);
    var dropDown2Data;
    if (criteriaRuleDataService.isEligibleCriterionFor2Multi(rule.criterion)) {
      dropDown2Data = dropDownData && dropDownData['2multi'];
      dropDownData = dropDownData && dropDownData[type];
    }
    if (rule.leftOperand && dropDownData && dropDownData.length === rule.leftOperand.length) {
      rule = createRuleForAllDataSelected(rule, dropDown2Data);
    } else if (rule.leftOperand && dropDownData && dropDownData.length > 2 && rule.leftOperand.length > dropDownData.length / 2) {
      rule = createReversedShorterRuleForUnselectedData(rule, dropDownData, dropDown2Data);
    }
    return rule;
  }
  function applicableDateRange(fields, rules) {
    var field = fields.split(',');
    var queryBuilder;
    return rules.map(function (rule) {
      var type = criteriaRuleService.getValueType(rule.searchContext, rule.level, rule.category, rule.criterion, rule.operator);
      var method = rsqlQueryService.getRsqlOperator(rule.operator, rule.leftOperand, rule.rightOperand || rule.leftOperand);
      var rsqlQuery = new RsqlQuery();
      var groupQuery = new RsqlQuery();
      var begin = field[0];
      var end = field[1];
      switch (method) {
        case 'equalTo':
          rule.rightOperand = rule.leftOperand;
          queryBuilder = rsqlQuery.is(begin).le(rsqlQueryService.formatOperand(rule.leftOperand, type)).and().is(end).ge(rsqlQueryService.formatOperand(rule.leftOperand, type));
          break;
        case 'ge':
          queryBuilder = rsqlQuery.is(end).ge(rsqlQueryService.formatOperand(rule.leftOperand, type));
          break;
        case 'inRange':
          queryBuilder = rsqlQuery.is(end).ge(rsqlQueryService.formatOperand(rule.leftOperand, type)).and().is(begin).le(rsqlQueryService.formatOperand(rule.rightOperand, type));
          break;
      }
      return groupQuery.and().orGroup(queryBuilder);
    });
  }
  function departureDateStrategy(field, rules) {
    return rules.map(function (rule) {
      var type = criteriaRuleService.getValueType(rule.searchContext, rule.level, rule.category, rule.criterion, rule.operator);
      var clonedRule = rule.clone();
      clonedRule.field = field;
      var method = rsqlQueryService.getRsqlOperator(clonedRule.operator, clonedRule.leftOperand, clonedRule.rightOperand || clonedRule.leftOperand);
      var rsqlQuery = new RsqlQuery();
      var groupQuery = new RsqlQuery();
      var queryBuilder = rsqlQuery.is(clonedRule.field);
      if (momentService.isMoment(clonedRule.leftOperand)) {
        clonedRule.leftOperand = clonedRule.leftOperand.startOf('day');
      }
      if (momentService.isMoment(clonedRule.rightOperand)) {
        clonedRule.rightOperand = clonedRule.rightOperand.startOf('day');
      }
      queryBuilder = queryBuilder[method].call(queryBuilder, rsqlQueryService.formatOperand(clonedRule.leftOperand, type), rsqlQueryService.formatOperand(clonedRule.rightOperand, type));
      return groupQuery.and().orGroup(queryBuilder);
    });
  }
  function transformToIncludeTime(moment) {
    if (moment.toString().length > momentService.getFormat('DATE_ISO').length) {
      return moment;
    }
    return momentService.copy(moment, momentService.TYPE.LOCAL_DATE_TIME);
  }
  function buildDateOperandsQuery(clonedRule, type) {
    var method = rsqlQueryService.getRsqlOperator(clonedRule.operator, clonedRule.leftOperand, clonedRule.rightOperand || clonedRule.leftOperand);
    var rsqlQuery = new RsqlQuery();
    var groupQuery = new RsqlQuery();
    var queryBuilder = rsqlQuery.is(clonedRule.field);
    if (method === 'equalTo' || method === 'notEqualTo') {
      clonedRule.rightOperand = clonedRule.leftOperand;
      method = method === 'equalTo' ? 'inRange' : 'notInRange';
    }
    if (method === 'inRange') {
      clonedRule.rightOperand = transformToIncludeTime(clonedRule.rightOperand.add(1, 'days')).startOf('day').subtract(1, 'seconds');
    } else if (method === 'notInRange') {
      clonedRule.leftOperand = transformToIncludeTime(clonedRule.leftOperand).startOf('day');
      clonedRule.rightOperand = transformToIncludeTime(clonedRule.rightOperand).endOf('day');
    } else if (method === 'le' || method === 'gt') {
      clonedRule.leftOperand = clonedRule.leftOperand.add(1, 'days');
    }
    queryBuilder = queryBuilder[method].call(queryBuilder, rsqlQueryService.formatOperand(clonedRule.leftOperand, type), rsqlQueryService.formatOperand(clonedRule.rightOperand, type));
    return groupQuery.and().orGroup(queryBuilder);
  }
  function createdDate(field, rules) {
    return rules.map(function (rule) {
      var type = criteriaRuleService.getValueType(rule.searchContext, rule.level, rule.category, rule.criterion, rule.operator);
      var clonedRule = rule.clone();
      clonedRule.field = field;
      clonedRule.leftOperand = clonedRule.leftOperand.startOf('day');
      return buildDateOperandsQuery(clonedRule, type);
    });
  }
  function numberDepartureDateStrategy(field, rules) {
    return rules.map(function (rule) {
      var type = criteriaRuleService.getValueType(rule.searchContext, rule.level, rule.category, rule.criterion, rule.operator);
      var clonedRule = rule.clone();
      clonedRule.field = field;
      return buildDateOperandsQuery(clonedRule, type);
    });
  }
  function daysToDepartureStrategy(field, rules) {
    var rsqlQuery = new RsqlQuery();
    var DISCARDED_CRITERIA = ['notInRange', 'notEqualTo'];
    return _.chain(rules).filter(function (rule) {
      var method = rsqlQueryService.getRsqlOperator(rule.operator, rule.leftOperand, rule.rightOperand || rule.leftOperand);
      return DISCARDED_CRITERIA.indexOf(method) === -1;
    }).transform(function (result, rule) {
      var method = rsqlQueryService.getRsqlOperator(rule.operator, rule.leftOperand, rule.rightOperand || rule.leftOperand);
      var now = momentService.now(momentService.FIELD.DEPARTURE_DATE);
      var queryBuilder = new RsqlQuery().is(field);
      var leftOperand = now.add(rule.leftOperand - 1, 'days').startOf('day');
      var rightOperand = '';
      if (method === 'inRange') {
        rightOperand = now.add(rule.rightOperand + 1, 'days').endOf('day');
      } else if (method === 'equalTo') {
        rightOperand = now.add(rule.leftOperand + 1, 'days').endOf('day');
        method = 'inRange';
      } else if (method === 'le' || method === 'lt') {
        leftOperand = now.add(rule.leftOperand + 1, 'days').endOf('day');
      }
      queryBuilder = queryBuilder[method].call(queryBuilder, rsqlQueryService.formatOperand(leftOperand), rsqlQueryService.formatOperand(rightOperand));
      return result.push(queryBuilder);
    }).reduce(function (query, rule) {
      return query.or().orGroup(rule);
    }, rsqlQuery).thru(function (query) {
      return query.isEmpty() ? [] : [query];
    }).value();
  }
  function eventLegStrategy(field, rules) {
    return marketGenericStrategy('events.legs[].origin', 'events.legs[].destination', rules);
  }
  function eventMarketStrategy(field, rules) {
    return marketGenericStrategy('events.origin', 'events.destination', rules);
  }
  function legStrategy(field, rules) {
    return marketGenericStrategy('legs.origin', 'legs.destination', rules, 'legs.market');
  }
  function segmentStrategy(field, rules) {
    return marketGenericStrategy('segments.origin', 'segments.destination', rules);
  }
  function marketStrategy(field, rules) {
    return marketGenericStrategy('origin', 'destination', rules, null, 'carrier');
  }
  function faresMarketStrategy(field, rules) {
    return marketGenericStrategy('marketOrigin', 'marketDestination', rules);
  }
  function eventFaresMarketStrategy(field, rules) {
    return marketGenericStrategy('events[].marketOrigin', 'events[].marketDestination', rules, null, 'events[].carrier');
  }
  function originDestinationStrategy(field, rules) {
    return marketGenericStrategy('origin', 'destination', rules);
  }
  function hasValidMarket(rule) {
    return _.isString(rule.leftOperand) && /([a-zA-Z\-]{3,5})-?([a-zA-Z\-]{3,5})?/.test(rule.leftOperand) || rule.leftOperand === EMPTY_VALUE || _.isString(rule.leftOperand2) && /([a-zA-Z\-]{2})?/.test(rule.leftOperand2);
  }
  function equalAllSelectedRule(rule) {
    return rule.operator === '!=' && rule.leftOperand === EMPTY_VALUE && rule.rightOperand === EMPTY_VALUE && !_.isArray(rule.leftOperand2);
  }
  function buildMarkets(result, rule) {
    if (_.isArray(rule.leftOperand)) {
      _.forEach(rule.leftOperand, function (market) {
        var newRule = rule.clone();
        newRule.leftOperand = market;
        if (_.isArray(rule.leftOperand2)) {
          newRule.leftOperand2 = rule.leftOperand2;
        }
        result.push(newRule);
      });
    } else {
      result.push(rule);
    }
    return result;
  }
  function buildMarketRule(originField, destinationField, marketField, carrierField, originalOperator, originalRule) {
    return function (result, rule) {
      var queryBuilder = new RsqlQuery();
      var market = rule.leftOperand || EMPTY_VALUE;
      var originDestination = market.split(/-/);
      var origin = originDestination[0] || EMPTY_VALUE;
      var destination = originDestination[1] || EMPTY_VALUE;
      var carriers = rule.leftOperand2;
      originalOperator = originalRule.operator === '=' ? '==' : '!=';
      if (!_.isUndefined(marketField) && !_.isNull(marketField) && !_.isEmpty(origin) && !_.isEmpty(destination)) {
        if (rule.operator === '!=') {
          queryBuilder = queryBuilder.is(marketField).notEqualTo(market);
        } else if (rule.operator === 'contains') {
          queryBuilder = queryBuilder.is(marketField)["in"](market);
        } else {
          queryBuilder = queryBuilder.is(marketField).equalTo(market);
        }
      } else {
        if (rule.operator === '!=') {
          queryBuilder = queryBuilder.is(originField).notEqualTo(origin).or().is(destinationField).notEqualTo(destination);
          if (!_.isUndefined(carriers) && !_.isEmpty(carriers)) {
            if (!_.isArray(rule.leftOperand)) {
              if (originalOperator !== rule.operator) {
                if (rule.leftOperand) {
                  // revese search
                  queryBuilder = new RsqlQuery().is(originField).notEqualTo(origin).and().is(destinationField).notEqualTo(destination).and().is(carrierField).out(carriers);
                } else if (_.isEmpty(rule.leftOperand)) {
                  // select all market
                  queryBuilder = new RsqlQuery().is(carrierField).out(carriers);
                }
              } else {
                // Normal search
                queryBuilder = queryBuilder.or().is(carrierField).out(carriers);
              }
            } else {
              // need to use case
              queryBuilder = queryBuilder.or().is(carrierField).out(carriers);
            }
          }
        } else if (rule.operator === 'contains') {
          queryBuilder = queryBuilder.is(originField)["in"](origin).or().is(destinationField)["in"](_.isEmpty(destination) ? origin : destination);
        } else {
          queryBuilder = queryBuilder.is(originField).equalTo(origin).and().is(destinationField).equalTo(destination);
          if (!_.isUndefined(carriers) && !_.isEmpty(carriers)) {
            queryBuilder = queryBuilder.and().is(carrierField)["in"](carriers);
          }
        }
      }
      return result.push(queryBuilder);
    };
  }
  function marketGenericStrategy(originField, destinationField, rules, marketField, carrierField) {
    var rsqlQuery = new RsqlQuery();
    var chain = _.chain(rules);
    chain = chain.map(updateSingleMultiRule);
    return chain.reject(equalAllSelectedRule).transform(buildMarkets).filter(hasValidMarket).transform(buildMarketRule(originField, destinationField, marketField, carrierField, rules[0].operator, rules[0])).reduce(function (query, rule) {
      if (rule.queue[1].operator.operator === '!=') {
        return query.and().andGroup(rule);
      } else {
        return query.or().orGroup(rule);
      }
    }, rsqlQuery).thru(function (query) {
      return query.isEmpty() ? [] : [query];
    }).value();
  }
  function mapToStrictDateComparisonOperators(operator) {
    return {
      "in": 'sdin',
      out: 'sdout',
      equalTo: 'sdeq',
      notEqualTo: 'sdne'
    }[operator];
  }
  function strictDateComparisonStrategy(field, rules) {
    return _.chain(rules).map(function (rule) {
      var type = criteriaRuleService.getValueType(rule.searchContext, rule.level, rule.category, rule.criterion, rule.operator);
      var operator = rsqlQueryService.getRsqlOperator(rule.operator, rule.leftOperand, rule.rightOperand || rule.leftOperand);
      var mappedOperator = mapToStrictDateComparisonOperators(operator);
      var rsqlQuery = new RsqlQuery();
      var groupQuery = new RsqlQuery();
      var queryBuilder = rsqlQuery.is(field);
      queryBuilder = queryBuilder[mappedOperator].call(queryBuilder, rsqlQueryService.formatOperand(rule.leftOperand, type), rsqlQueryService.formatOperand(rule.rightOperand, type));
      return groupQuery.and().orGroup(queryBuilder);
    }).reject(_.isNull).value();
  }
  return {
    "default": defaultStrategy,
    leg: legStrategy,
    originDestination: originDestinationStrategy,
    eventLeg: eventLegStrategy,
    eventMarket: eventMarketStrategy,
    daysToDeparture: daysToDepartureStrategy,
    departureDate: departureDateStrategy,
    numberDepartureDate: numberDepartureDateStrategy,
    creationDate: numberDepartureDateStrategy,
    market: marketStrategy,
    faresMarket: faresMarketStrategy,
    applicableDateRange: applicableDateRange,
    alwaysSendValues: alwaysSendValuesStrategy,
    createdDate: createdDate,
    segment: segmentStrategy,
    strictDateComparison: strictDateComparisonStrategy,
    eventFaresMarket: eventFaresMarketStrategy
  };
};
RsqlQueryGroupStrategies.$inject = ['RsqlQueryFactory', 'RsqlQueryService', 'CriteriaRuleService', 'CriteriaRuleDataService', 'MomentService', 'UserSearchService'];
module.exports = RsqlQueryGroupStrategies;